module.exports = __webpack_public_path__ + "media/icons/icon_dcf-fdd1bac5.png";